export default function Footer() {
  return (
    <footer className="bg-[#1a3a2e] text-white pt-24 pb-16 relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-8">
        {/* Four-Column Grid */}
        <div className="grid grid-cols-4 gap-12 mb-20">
          {/* Column 1 - Brand Identity */}
          <div>
            <div className="text-[20px] font-medium mb-6">MIKRA d.o.o.</div>
            <p className="text-[13px] leading-[1.6] text-[#b8c4be]">
              Crafting premium iOS applications for enhanced security and performance.
            </p>
          </div>

          {/* Column 2 - Newsletter */}
          <div>
            <div className="text-[11px] uppercase tracking-[1.5px] text-[#9aa89f] mb-5 font-medium">
              STAY UPDATED
            </div>
            <div className="relative">
              <input
                type="email"
                placeholder="Enter email"
                className="w-[85%] bg-transparent border-b border-[#4a6a5a] pb-2 text-[14px] text-white placeholder-[#7a9a8a] focus:outline-none focus:border-[#d4ff00] transition-colors"
              />
              <button className="absolute right-[15%] bottom-2 cursor-pointer">
                <i className="ri-arrow-right-line text-[#7a9a8a] hover:text-[#d4ff00] transition-colors"></i>
              </button>
            </div>
            <div className="mt-3">
              <a href="#" className="text-[11px] text-[#7a9a8a] underline hover:text-[#d4ff00] transition-colors cursor-pointer">
                Privacy policy
              </a>
            </div>
          </div>

          {/* Column 3 - Quick Links */}
          <div>
            <div className="text-[11px] uppercase tracking-[1.5px] text-[#9aa89f] mb-5 font-medium">
              PRODUCTS
            </div>
            <div className="space-y-4">
              <a href="#products" className="block text-[14px] text-white hover:text-[#d4ff00] transition-colors cursor-pointer">
                VPN Protection
              </a>
              <a href="#products" className="block text-[14px] text-white hover:text-[#d4ff00] transition-colors cursor-pointer">
                System Cleaner
              </a>
              <a href="#products" className="block text-[14px] text-white hover:text-[#d4ff00] transition-colors cursor-pointer">
                Features
              </a>
            </div>
          </div>

          {/* Column 4 - Contact Info */}
          <div>
            <div className="text-[11px] uppercase tracking-[1.5px] text-[#9aa89f] mb-5 font-medium">
              CONTACT
            </div>
            <div className="space-y-4">
              <a href="mailto:support@mikradoo.com" className="block text-[14px] text-white hover:text-[#d4ff00] transition-colors cursor-pointer">
                support@mikradoo.com
              </a>
              <a href="tel:+13158608764" className="block text-[14px] text-white hover:text-[#d4ff00] transition-colors cursor-pointer">
                +1 3158608764
              </a>
              <div className="text-[14px] text-white">
                Duga Resa, Croatia
              </div>
            </div>
          </div>
        </div>

        {/* Large Brand Typography */}
        <div className="relative text-center mb-12">
          <div 
            className="text-[180px] font-bold text-[#e8dcc8]/60 leading-none tracking-[-4px]"
            style={{ fontFamily: 'Arial, sans-serif' }}
          >
            MIKRA
          </div>
        </div>

        {/* Bottom Copyright */}
        <div className="border-t border-[#4a6a5a] pt-8 flex items-center justify-between">
          <div className="text-[13px] text-[#9aa89f]">
            © 2024 MIKRA d.o.o. All rights reserved.
          </div>
          <div>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[13px] text-[#9aa89f] hover:text-[#d4ff00] transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
